<template>
	<div>
		<Billingcomponent
			:outerVisible="outerVisible"
			@closeouterVisible="closeouterVisible"
			:ruleFormb="allitem.ruleFormb"
			:priceall="allitem.priceall"
			:totalall="allitem.totalall"
			:ruleFormbxiao="allitem.ruleFormbxiao"
			:form_chae="allitem.form_chae"
			:bztext="allitem.bztext"
			:stateall="allitem.stateall"
			:listoflists="allitem.listoflists"
			:invoiceNo="allitem.invoiceNo"
			:invoiceCode="allitem.invoiceCode"
			:billingDate="allitem.billingDate"
			title="预览发票"
			:documentStatus="allitem.documentStatus"
			:checkCode="allitem.checkCode"
		></Billingcomponent>
		<DetailsImport
			:title="title"
			:kaipr="kaipr"
			:totalall="totalall"
			:danjh="danjh"
			:id="id"
			:ruleFormbxiao="ruleFormbxiao"
			:stateall="stateall"
			:tedxx="tedxx"
			:bztext="bztext"
			:jbrdata="jbrdata"
			:srk="srk"
			:ruleFormb="ruleFormb"
			:priceall="priceall"
			:Preview="Preview"
			@closediagew="closediagew"
			:tdywxz="tdywxz"
		></DetailsImport>
		<el-dialog title="选择模板" :visible.sync="mbdialog" width="700px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="mbtitle" :isdiag="true"></minhead> -->
			<el-table :data="tableDatatan" border style="width: 95%;margin-left: 2.5%;" @row-click="radiochangenochoose">
				<el-table-column width="55" align="center">
					<template slot-scope="scope">
						<el-radio :label="scope.$index" v-model="radionochoose"></el-radio>
					</template>
				</el-table-column>
				<el-table-column label="模板模式" align="center">
					<template slot-scope="scope">
						<div class="Centerhorizontally">
							<span :style="scope.row.mos == 1 ? 'font-size: 14px;color: #FF8800;margin-right:8px' : 'font-size: 14px;color: #0080FF;margin-right:8px'">
								{{ mostostring(scope.row.mos) }}
							</span>
							<img src="../../../assets/img/chu.png" width="16px" height="16px" v-if="scope.row.mos == 1" />
							<img src="../../../assets/img/ru.png" width="16px" height="16px" v-if="scope.row.mos == 2" />
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="mingc" label="模板名称" align="center"></el-table-column>
				<el-table-column label="创建时间" align="center">
					<template slot-scope="scope">
						<span>{{ formatdate(scope.row.createTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="更新时间" align="center">
					<template slot-scope="scope">
						<span>{{ formatdate(scope.row.updateTime) }}</span>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<!-- <div class="rightbuttom">
					<div @click="exportByTemplate">确定</div>
					<div @click="mbdialog = false">取消</div>
				</div> -->
				<div style="justify-content: center; display: flex;margin-right: 17px;">
					<div class="addstyle" style="width:60px;margin-right: 20px;" @click="exportByTemplate()">确定</div>
					<div class="backstyle" style="width:60px" @click="mbdialog = false">取消</div>
				</div>
			</div>
		</el-dialog>
		<!-- :title="title" -->
		<!-- :HongChongtype="HongChongtype" -->
		<taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai"></taxSearch>
		<div class="headline"></div>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<!--  <el-button
              type="primary"
              plain
              @click="forshuai('form')"
              style="width: 100px;"
          >查询
          </el-button> -->
					<!-- <div class="addstyle" @click="forshuai('form')" style="width: 100px;margin-right: 10px;	"><samp>查询</samp></div> -->
					<!-- <el-button
              type="primary"
              plain
              @click="resetForm('form')"
              style="width: 100px;"
          >重置
          </el-button> -->
					<!-- <div class="addstyle" @click="resetForm('form')" style="width: 100px;margin-right: 10px;	"><samp>重置</samp></div> -->
					<!-- <el-button type="primary" plain style="width: 100px;" @click="printDoc" >
            发票打印
            <i class="el-icon-thumb el-icon--right"></i>
          </el-button> -->
					<div class="addstyle" @click="printDoc" style="width: 100px;margin-right: 10px;	" v-if="permissionButton('fpcx_fpdy','InvoiceQuery_FullyElectronic_invoice_printing')">
						<samp>
							发票打印
							<i class="el-icon-thumb el-icon--right"></i>
						</samp>
					</div>

					<!-- <el-button type="primary" @click="printDocList" plain >
            清单打印
            <i class="el-icon-upload2 el-icon--right"></i>
          </el-button> -->
					<div class="addstyle" @click="printDocList" style="width: 100px;margin-right: 10px;	" v-if="permissionButton('fpcx_qddy','InvoiceQuery_FullyElectronic_list_printing')">
						<samp>
							清单打印
							<i class="el-icon-upload2 el-icon--right"></i>
						</samp>
					</div>

					<el-dropdown class="avatar-container" trigger="click">
						<!--    <div class="avatar-wrapper">
              <el-button type="primary" plain>
                下载PDF文件
                <i class="el-icon-caret-bottom"/>
              </el-button>
            </div> -->
						<div class="addstyle" style="width: 120px;margin-right: 10px;	" v-if="permissionButton('fpcx_xzpdfwj','InvoiceQuery_FullyElectronic_download_file')">
							<samp>
								下载版式文件
								<i class="el-icon-caret-bottom" />
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="downloadDoc('0')">所有文件</el-dropdown-item>
							<el-dropdown-item @click.native="downloadDoc('3')">XML文件</el-dropdown-item>
							<el-dropdown-item @click.native="downloadDoc('2')">OFD文件</el-dropdown-item>
							<el-dropdown-item @click.native="downloadDoc('1')">PDF文件</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-dropdown class="avatar-container" trigger="click" style="margin:0 0px">
						<!--   <div class="avatar-wrapper">
              <el-button type="primary" plain>
                导出
                <i class="el-icon-caret-bottom"/>
              </el-button>
            </div> -->
						<div class="addstyle" style="width: 100px;margin-right: 10px;	" v-if="permissionButton('fpcx_dc','InvoiceQuery_FullyElectronic_export')">
							<samp>
								导出
								<i class="el-icon-caret-bottom" />
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="excelExport('0')">导出发票头</el-dropdown-item>
							<el-dropdown-item @click.native="excelExport('1')">导出发票明细</el-dropdown-item>
							<el-dropdown-item @click.native="excelExport('2')">导出显示列发票头</el-dropdown-item>
							<el-dropdown-item @click.native="excelExport('3')">导出显示列发票明细</el-dropdown-item>
							<el-dropdown-item @click.native="excelExport('4')">导出自定义模板</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<!--            <el-button type="primary" plain @click.native="excelExport" v-permission='fpcx_dc'>-->
					<!--                导出-->
					<!--                <i class="el-icon-top-right"/>-->
					<!--            </el-button>-->
				</div>
				<div style="padding-left: 20px; margin-right: 30px;"><img src="../../../assets/img/filterimg.svg" width="24px" height="24px" @click="filterClick" /></div>
			</div>
		</div>

		<Taxtable
			style="margin:16px 16px 0px 16px"
			:headData="headData"
			tableHeight="calc(100vh - 370px )"
			showoverflowtooltip
			showPagination
			showSelection
			ref="tablebox"
			:tableData="tableData"
			@sizChange="handleSizeChange"
			@currentChange="handleCurrentChange"
			@selectionchange="handleSelectionChange"
			@sortchange="sortChange"
			:pagination="pagination"
			@cellclick="selectClick"
			:pagesizes="[10, 50, 200, 300, 500, 800, 1000]"
		>
			<template v-slot:fapzt="scope">
				<p v-if="scope.taxval.fapzt == '1'" style="color:#00DC16">已审核</p>
				<p v-if="scope.taxval.fapzt == '2'" style="color:#EE0101">待开票</p>
				<p v-if="scope.taxval.fapzt == '3'" style="color:#2F66FC">开票中</p>
				<p v-if="scope.taxval.fapzt == '4'" style="color:#FF8000">已开票</p>
				<p v-if="scope.taxval.fapzt == '5'" style="color:#FF8000">已作废</p>
				<p v-if="scope.taxval.fapzt == '6'" style="color:#FF8000">已红冲</p>
				<p v-if="scope.taxval.fapzt == '7'" style="color:#BEBEBE">开票失败</p>
				<p v-if="scope.taxval.fapzt == '8'" style="color:#00DC16">暂不开票</p>
				<p v-if="scope.taxval.fapzt == '9'" style="color:#00DC16">已退票</p>
				<p v-if="scope.taxval.fapzt == '10'" style="color:#00DC16">已合并</p>
				<p v-if="scope.taxval.fapzt == '21'" style="color:#00DC16">作废关闭中</p>
				<p v-if="scope.taxval.fapzt == '22'" style="color:#00DC16">作废重开中</p>
				<p v-if="scope.taxval.fapzt == '23'" style="color:#00DC16">作废锁定</p>
				<p v-if="scope.taxval.fapzt == '31'" style="color:#00DC16">未开发票冲销</p>
				<p v-if="scope.taxval.fapzt == '32'" style="color:#00DC16">已开发票冲销</p>
				<p v-if="scope.taxval.fapzt == '33'" style="color:#00DC16">作废冲销</p>
				<p v-if="scope.taxval.fapzt == '34'" style="color:#00DC16">无需开票</p>
				<p v-if="scope.taxval.fapzt == '35'" style="color:#00DC16">待作废</p>
			</template>
			<template v-slot:fapzl="scope">
				<p v-if="scope.taxval.fapzl == '1'">税控发票</p>
				<p v-if="scope.taxval.fapzl == '2'">数电发票</p>
			</template>
			<template v-slot:tedywlx="scope">
				<p v-if="scope.taxval.tedywlx == '01'">成品油</p>
				<p v-if="scope.taxval.tedywlx == '02'">稀土</p>
				<p v-if="scope.taxval.tedywlx == '03'">建筑服务</p>
				<p v-if="scope.taxval.tedywlx == '04'">货物运输</p>
				<p v-if="scope.taxval.tedywlx == '05'">不动产销售</p>
				<p v-if="scope.taxval.tedywlx == '06'">不动产经营租赁</p>
				<p v-if="scope.taxval.tedywlx == '07'">代收车船使用税</p>
				<p v-if="scope.taxval.tedywlx == '08'">通行费</p>
				<p v-if="scope.taxval.tedywlx == '09'">旅客运输</p>
				<p v-if="scope.taxval.tedywlx == '10'">医疗服务</p>
				<p v-if="scope.taxval.tedywlx == '11'">农产品</p>
				<p v-if="scope.taxval.tedywlx == '12'">拖拉机和联合收割机</p>
				<p v-if="scope.taxval.tedywlx == '13'">机动车</p>
				<p v-if="scope.taxval.tedywlx == '14'">光伏收购</p>
				<p v-if="scope.taxval.tedywlx == '15'">卷烟</p>
			</template>
			<template v-slot:faplxdm="scope">
				<p v-if="scope.taxval.faplxdm == '026'">电子普票</p>
				<p v-if="scope.taxval.faplxdm == '028'">电子专票</p>
				<p v-if="scope.taxval.faplxdm == '007'">纸质普票</p>
				<p v-if="scope.taxval.faplxdm == '004'">纸质专票</p>
			</template>

			<template v-slot:faphm="scope">
				<el-button type="text" size="small" @click="handleClick(scope.index, '预览发票', scope.taxval)">{{ scope.taxval.faphm }}</el-button>
			</template>

			<template v-slot:kaiprq="scope">
				<div class="Centerhorizontally">{{ stringtostmp(scope.taxval.kaiprq) }}</div>
			</template>
			<template v-slot:chuangjrq="scope">
				<div class="Centerhorizontally">{{ stringtostmp(scope.taxval.chuangjrq) }}</div>
			</template>
			<template v-slot:dayzt="scope">
				<p v-if="scope.taxval.dayzt == '2'">已打印</p>
				<p v-else>未打印</p>
			</template>
			<template v-slot:hasList="scope">
				<p v-if="scope.taxval.hasList == '1'">是</p>
				<p v-else>否</p>
			</template>
			<template v-slot:kaiplx="scope">
				<p v-if="scope.taxval.kaiplx == '1'">是</p>
				<p v-else>否</p>
			</template>
			<template v-slot:qingddyzt="scope">
				<p v-if="scope.taxval.qingddyzt == '2'">已打印</p>
				<p v-else>未打印</p>
			</template>
			<template v-slot:diszt="scope">
				<div class="Centerhorizontally">
					<img src="../../../assets/img/yts.png" width="31px" height="32px" v-if="scope.taxval.emailSendState === '1'" />
					<img src="../../../assets/img/yts.png" width="31px" height="32px" v-else-if="scope.taxval.cardSendState === '1'" />
					<span v-else>未推送</span>
				</div>
			</template>
		</Taxtable>
		<div class="lastend">
			<div>
				当前已勾选
				<span>{{ selectCount }}</span>
				条
			</div>
			<div>
				合计金额
				<span>￥{{ toThousands(Amountformat(jiastotalSum)) }}</span>
			</div>
			<div>
				合计税额
				<span>￥{{ toThousands(Amountformat(taxtotalSum)) }}</span>
			</div>
		</div>

		<filterdiag :visible="shaidiag" @closediag="closeshaidiag" :fliterlist="headData" :outlist="outlist" @confirmfilter="confirmfilter"></filterdiag>
	</div>
</template>

<script>
var _this;
import { tableheadData } from '../../crud/InvoiceQuery';
import DetailsImport from '../FullyElectronicInvoices/FillingPositiveInvoice/DetailsImport/index.vue';
export default {
	components: {
		DetailsImport
	},
	data() {
		return {
			searchlist: [
				{
					prop: 'faplxdm',
					label: '发票类型',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '纸质普票',
							value: '007'
						},
						{
							label: '纸质专票',
							value: '004'
						},
						{
							label: '电子普票',
							value: '026'
						},
						{
							label: '电子专票',
							value: '028'
						}
					]
				},
				{
					prop: 'faphm',
					label: '发票号码',
					type: 'input'
				},
				{
					prop: 'fapdm',
					label: '发票代码',
					type: 'input'
				},
				{
					prop: 'kaiprq',
					label: '开票日期',
					type: 'date',
					valueformat: 'yyyy-MM-dd'
				},
				{
					prop: 'danjh',
					label: '单据号',
					type: 'input'
				},
				{
					prop: 'hejje',
					label: '金额',
					type: 'input'
				},
				{
					prop: 'hejse',
					label: '税额',
					type: 'input'
				},
				{
					prop: 'chuangjrq',
					label: '创建日期',
					type: 'date',
					valueformat: 'yyyy-MM-dd'
				},
				{
					prop: 'goufmc',
					label: '购方名称',
					type: 'input'
				},
				{
					prop: 'faply',
					label: '发票来源',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '文件导入',
							value: '1'
						},
						{
							label: '手工录入',
							value: '2'
						},
						{
							label: '客户接口',
							value: '3'
						},
						{
							label: '税控同步',
							value: '4'
						},
						{
							label: '支付开票',
							value: '5'
						},
						{
							label: '扫码开票',
							value: '6'
						},
						{
							label: '红冲重开',
							value: '7'
						},
						{
							label: '作废重开',
							value: '8'
						}
					]
				},
				{
					prop: 'fapzt',
					label: '单据状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '已开票',
							value: '4'
						},
						{
							label: '已作废',
							value: '5'
						},
						{
							label: '已红冲',
							value: '6'
						}
					]
				},
				{
					prop: 'yuanfpdm',
					label: '原发票代码',
					type: 'input'
				},
				{
					prop: 'yuanfphm',
					label: '原发票号码',
					type: 'input'
				},
				{
					prop: 'diszt',
					label: '递送状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '已递送',
							value: '1'
						},
						{
							label: '未递送',
							value: '0'
						}
					]
				},
				{
					prop: 'dayzt',
					label: '打印状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '已打印',
							value: '2'
						},
						{
							label: '未打印',
							value: '0'
						}
					]
				},
				{
					prop: 'shifqd',
					label: '是否清单',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '是',
							value: '1'
						},
						{
							label: '否',
							value: '0'
						}
					]
				},
				{
					prop: 'kaiplx',
					label: '是否负数',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '是',
							value: '1'
						},
						{
							label: '否',
							value: '0'
						}
					]
				},
				{
					prop: 'zhidr',
					label: '制单人',
					type: 'input'
				},
				{
					prop: 'shenqr',
					label: '申请人',
					type: 'input'
				},
				{
					prop: 'zidysm',
					label: '自定义说明',
					type: 'input'
				},
				{
					prop: 'beiz',
					label: '备注',
					type: 'input'
				},
				{
					prop: 'kaipzddm',
					label: '税盘编号',
					type: 'input'
				},
				{
					prop: 'tspz',
					label: '特殊票种',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '非特殊票种',
							value: '00'
						},
						{
							label: '收购',
							value: '02'
						},
						{
							label: '抵扣通行费',
							value: '06'
						},
						{
							label: '不抵扣通行费',
							value: '07'
						},
						{
							label: '成品油',
							value: '08'
						},
						{
							label: '机动车',
							value: '01'
						}
					]
				},
				{
					prop: 'tedywlx',
					label: '特殊业务',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '成品油',
							value: '01'
						},
						{
							label: '稀土',
							value: '02'
						},
						{
							label: '建筑服务',
							value: '03'
						},
						{
							label: '不动产经营租赁',
							value: '06'
						},
						{
							label: '机动车',
							value: '13'
						}
					]
				},
				{
					prop: 'fapzl',
					label: '发票种类',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '税控发票',
							value: '1'
						},
						{
							label: '数电发票',
							value: '2'
						}
					]
				}
			],
			mbtitle: ['选择模板'],
			mbdialog: false,
			radionochoose: '',
			changerow: '',
			tableDatatan: [{}, {}, {}, {}],

			isQuery: false,
			isshou: true,
			cxdialog: false,
			page: 1,
			pagenum: 10,
			totalcount: 10,
			tableData: [],
			headtitle: ['发票管理', '发票查询'],
			tableHeight: 0,
			currentpage: 1,
			elementui_page_component_key: '',
			selectRows: [],
			selectIds: [],
			selectCount: 0,
			jiastotalSum: 0,
			taxtotalSum: 0,
			allitem: {},
			allitemList: [],
			outerVisible: false,
			searchalllist: {
				faplxdm: '',
				faply: '',
				fapdm: '',
				faphm: '',
				danjh: '',
				fapzt: '',
				goufmc: '',
				hejje: '',
				hejse: '',
				kaiprq: '',
				chuangjrq: '',
				dayzt: '',
				shifqd: '',
				qingddyzt: '',
				diszt: '',
				yuanfpdm: '',
				yuanfphm: '',
				zidysm: '',
				beiz: '',
				kaipzddm: ''
			},
			orderInfo: {},
			shaidiag: false,
			headData: tableheadData,
			outlist: [],
			pagination: {
				pageNum: 1,
				pageSize: 10,
				total: 0
			},
			//数电
			//销方信息
			ruleFormbxiao: {
				name: '', //销售方名称
				taxNumber: '', //销售方名称纳税人识别号
				addressPhone: '', //销售方名称地 址、电 话
				bankAccount: '', //销售方名称开户行及账号
				bpayee: '', //收款人
				breview: '', //复 核
				bdrawer: '' //开票人
			},
			//购方信息
			ruleFormb: {
				customerName: '', //购买方名称
				taxIdentificationNumber: '', //购买方纳税人识别号
				address: '', //购买方地 址、电 话
				bank: '' //购买方开户行及账号
			},
			//状态
			stateall: {
				istaxincluded: false, //是否含税
				choosetitleindex: '' //发票类型 新增也要传
			},
			//票据明细
			priceall: [{}, {}, {}, {}, {}, {}, {}, {}],
			//附加信息
			srk: [],
			//经办人信息
			jbrdata: {
				xingm: '',
				guoj: '',
				zhengjlx: '',
				bank: '',
				qiybh: ''
			},
			//特定业务
			tdywxz: '',
			//差额征税 减按征税
			cezsxz: '',
			jazsxz: '',
			//特定业务类型
			tedxx: {
				qiybh: '',
				jianzfwfsd: '',
				fasdxxdz: '',
				jianzxmmc: '',
				tudzzsxmbh: '',
				budcdz: '',
				budcxxdz: '',
				zulqqzulqz: ['', ''],
				kuadsbz: '',
				budcqzhm: '',
				mianjdw: ''
			},
			id: '',
			title: '',
			//单据号
			danjh: '',
			//合计
			totalall: {},
			//备注
			bztext: '',
			//开票人
			kaipr: '',
			Preview: false,
			pageRoles:"",
			pageRolesButtons:{},
		};
	},
	activated(){
		console.log("activated")
	},
	watch: {
	  '$route': 'refreshData'
	},
	created() {
		console.log("============>")
		console.log(this.$route)

		this.getInvoiceQueryList();
		this.loadPermissionButton();
		
	},
	mounted() {
		_this = this;
		this.repairtable();

		let invoiceQueryTabelShow = localStorage.getItem('invoiceQueryTabelShow');
		if (invoiceQueryTabelShow != null && invoiceQueryTabelShow != '') {
			let data = JSON.parse(invoiceQueryTabelShow);
			this.headData = data.headData;
			console.log(this.headData);
			this.outlist = data.outlist;
		} else {
		}
	},
	methods: {
		refreshData() {
			// 刷新数据的代码
			console.log('refreshData');
			this.loadPermissionButton();
		},
		loadPermissionButton() {
		    this.pageRoles = this.$route.meta.roles[0]
			var userFunction = JSON.parse(localStorage.getItem('userFunction'));
			userFunction.forEach(item => {
				if (this.notemptyandnull(item.children)) {
					item.children.forEach(gtem => {
						if (gtem.index == this.pageRoles) {
							this.pageRolesButtons = JSON.parse(JSON.stringify(gtem.buttomroute));
							console.log(this.pageRolesButtons)
						}
					});
				}
			});
		},
		permissionButton(...ifRoles) {
			for (let i = 0; i < ifRoles.length; i++) {
				let str = ifRoles[i];
				let haveButton = this.pageRolesButtons[str];
				if (!!haveButton){
					return true
				} 

			}
			return false;
		},
		closediagew() {
			this.Preview = false;
		},
		filterClick() {
			this.shaidiag = true;
		},
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			let invoiceQueryTabelShow = { headData: this.headData, outlist: this.outlist };
			localStorage.setItem('invoiceQueryTabelShow', JSON.stringify(invoiceQueryTabelShow));
			this.shaidiag = false;
		},

		/* 列表 */
		getImportTemplate() {
			let shitlmc = 'Doc';
			let params = { shitlmc: shitlmc, type: '2' };
			this.$https.fetchPost('import/getImportTemplate', JSON.stringify(params)).then(res => {
				if (res.data.success) {
					this.mbdialog = true;
					this.tableDatatan = res.data.data;
				}
			});
		},
		exportByTemplate() {
			if (!this.changerow.id) {
				this.$message.error('请先选择模板');
				return false;
			}
			let tempId = this.changerow.id;
			// 条件框
			var newForm = JSON.parse(JSON.stringify(this.searchalllist));
			if (newForm.kaiprq) {
				newForm.kaiprq = newForm.kaiprq.join(',');
			}
			if (newForm && newForm.chuangjrq) {
				newForm.chuangjrq = newForm.chuangjrq.join(',');
			}
			// 通过ids 传递模板的id
			newForm.tempId = tempId;
			newForm.ids = this.selectIds.toString();
			let params = {
				page: this.page,
				limit: this.pagenum,
				sort: 'desc',
				order: 'rd.kaiprq',
				search: newForm
			};

			this.$https.fetchdowload('/real/exportRealDocByTemplate', params).then(res => {
				const content = res.data;
				const blob = new Blob([content]);
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				var companyName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
				const fileName = companyName + date + '发票查询' + '.xls';
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
			});

			this.mbdialog = false;
			(this.radionochoose = ''), (this.changerow = '');
		},
		radiochangenochoose(row, event, column) {
			this.changerow = row;
		},
		repairtable() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheightzhengshutiankai();
				setTimeout(() => {
					this.$refs.multipleTable.doLayout();
				}, 300);
				window.onresize = () => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
				};
			});
		},
		sortChange(column) {
			var issuccess = false;
			//获取字段名称和排序类型
			var fieldName = column.prop;
			var sortingType = this.getHqlOrderType(column.order);
			this.orderInfo[fieldName] = sortingType;
			issuccess = true;
			if (issuccess) {
				this.getInvoiceQueryList(this.orderInfo);
			}
		},
		selectClick(row, column, event) {
			var selectRow = [];
			selectRow.push(row);
			this.$refs.tablebox.toggleSelection(selectRow);
		},
		// handleHeadAddClass({column}){
		//      if(this.orderInfo[column.property]){
		//        column.order = this.getVueOrderType(this.orderInfo[column.property]);
		//      }
		//    },
		closeouterVisible() {
			this.outerVisible = false;
		},
		changeshou() {
			this.isshou = !this.isshou;
		},
		// forserch() {
		//     this.currentpage = 1;
		//     this.elementui_page_component_key++;
		//     this.page = 1;
		//     this.getInvoiceQueryList();
		// },
		/* table选中发生改变 */
		handleSelectionChange(e) {
			console.log(e);
			this.selectRows = [];
			this.selectIds = [];
			this.selectCount = 0;
			this.jiastotalSum = 0;
			this.taxtotalSum = 0;
			e.forEach((item, index) => {
				this.selectCount++;
				this.selectIds.push(item.id);
				this.selectRows.push(item);
				console.log(this.jiastotalSum);
				this.jiastotalSum = this.printFn(parseFloat(this.jiastotalSum) + parseFloat(item.hejje));
				this.taxtotalSum = this.printFn(parseFloat(this.taxtotalSum) + parseFloat(item.hejse));
			});
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.getInvoiceQueryList();
		},
		handleCurrentChange(val) {
			this.pagination.pageNum = val;
			this.getInvoiceQueryList();
		},
		resetForm(formName) {
			Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
		},
		forshuai() {
			/* this.$refs['form'].validate(valid => {
           if (!valid) {
               return false;
           }
       });*/
			// this.searchalllist.listlikeSearch = '';
			this.isQuery = true;
			this.elementui_page_component_key++;
			this.page = 1;
			this.currentpage = 1;
			this.getInvoiceQueryList();
			this.$refs.multipleTable.clearSort();
			this.cxdialog = false;
		},

		//除法计算
		numdiv(arg1, arg2) {
			var t1 = 0,
				t2 = 0,
				r1,
				r2;
			try {
				t1 = arg1.toString().split('.')[1].length;
			} catch (e) {}
			try {
				t2 = arg2.toString().split('.')[1].length;
			} catch (e) {}
			//with(Math){
			r1 = Number(arg1.toString().replace('.', ''));
			r2 = Number(arg2.toString().replace('.', ''));
			return (r1 / r2) * Math.pow(10, t2 - t1);
			//}
		},
		getInvoiceQueryList(orderInfo) {
			var newForm = JSON.parse(JSON.stringify(this.searchalllist));
			if (newForm && newForm.kaiprq) {
				newForm.kaiprq = newForm.kaiprq.join(',');
			}
			if (newForm && newForm.chuangjrq) {
				newForm.chuangjrq = newForm.chuangjrq.join(',');
			}
			newForm.orderInfo = JSON.stringify(this.orderInfo);
			let params = {
				page: this.pagination.pageNum,
				limit: this.pagination.pageSize,
				search: newForm
			};
			this.title = '';
			this.allitem = {};
			this.outerVisible = false;
			this.$https.fetchPost('/real/getRealDocQueryList', params).then(res => {
				this.tableData = res.data.data;
				this.pagination.total = res.data.count;
				this.allitemList = res.data.allitem; // 预览用的数据
			});
		},
		getHqlOrderType(sortType) {
			switch (sortType) {
				case 'ascending':
					return 'asc';
					break;
				case 'descending':
					return 'desc';
					break;
			}
		},
		getVueOrderType(sortType) {
			switch (sortType) {
				case 'desc':
					return 'ascending';
					break;
				case 'asc':
					return 'descending';
					break;
			}
		},
		printPost(printDetail) {
			if (0 === this.selectRows.length) {
				this.$message.error('请选择需要打印的发票');
				return;
			}
			if (!this.selectRows.every(row => row.faplxdm === this.selectRows[0].faplxdm)) {
				this.$message.error('请选择相同类型的发票');
				return;
			}
			let minFapdm = this.selectRows[0].faphm;
			let agindyfp = [];
			let yidy = [];
			let ids = [];
			this.selectRows.forEach(row => {
				if (minFapdm > row.faphm) {
					minFapdm = row.faphm;
				}
				ids.push(row.id);
				agindyfp.push(row.faphm);
				if (row.dayzt == '2') {
					yidy.push(row.faphm);
				}
			});
			agindyfp.sort(function(a, b) {
				return a - b;
			});
			if (!printDetail && !this.checkSort(agindyfp)) {
				this.$alert(`选择的发票号码序列${agindyfp}存在跳号发票无法打印，请重新选择。`, '提示', {
					confirmButtonText: '确定'
				});
				return;
			}
			ids.sort(function(a, b) {
				return a - b;
			});
			let params = {
				ids: ids.join(','),
				printDetail: printDetail
			};
			let alertText = '';
			if (this.notemptyandnull(yidy)) {
				alertText = '选中发票中有发票号码为' + yidy.join('、') + '的发票已打印,请确认是否需要再次打印！并确认发票号码与系统是否一致';
			} else {
				alertText = '从发票号码为' + agindyfp.join('、') + '的顺序进行打印，是否确认打印';
			}
			const h = this.$createElement;
			const message = h('div', { style: 'position:relative', class: '' }, [
				h('el-scrollbar', { 'wrap-style': 'overflow-y: scroll; overflow-x: hidden;', class: 'h' }, [h('div', { style: ';padding-bottom:15px' }, alertText)])
			]);
			this.$confirm(message, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				lockScroll: false
			}).then(() => {
				this.$https
					.fetchPost('/outputinv/opinvmb/printInvoiceMb', JSON.stringify(params))
					.then(
						res => {
							let data = res.data.data;
							for (let i = 0; i < data.data.length; i++) {
								if (printDetail) {
									data.data[i].sfsyqdbj = 1;
								} else {
									data.data[i].sfsyqdbj = 0;
								}
							}
							this.printPaperInvWs(res.wsurl, data, params);
						},
						err => {
							// reject(err);
							console.info(err);
						}
					)
					.catch(err => {
						console.info(err);
					});
			});
		},
		printDoc() {
			// 发票打印
			this.printPost(false);
		},
		printDocList() {
			// 清单打印
			this.printPost(true);
		},
		downloadDoc(fileType) {
			let dianzOrZhizFpFlag;
			// 下载板式文件 TODO 支持纸票pdf
			if (this.selectRows.length == 0) {
				this.$message.error('请选择需要下载的发票');
				return;
			}
			/* if (this.selectRows.length > 1) {
   this.$message.error("一次只能下载一张发票的版式文件")
           return;
       }*/
			if (this.selectRows.every(row => row.faplxdm === '026' || row.faplxdm === '028')) {
				// this.$message.error("当前仅支持电子发票下载")
				// return;
				dianzOrZhizFpFlag = true;
			} else {
				dianzOrZhizFpFlag = false;
			}
			if (!dianzOrZhizFpFlag) {
				if (fileType == 2) {
					this.$message.error('纸质普通发票仅支持PDF版式文件下载');
					return;
				}
			}
			var ids = [];
			this.selectRows.forEach((item, index) => {
				ids.push(item.id);
			});
			let row = this.selectRows[0];
			let params = {
				ids: ids,
				fileType: fileType
			};
			this.$https.fetchdowload('real/downloadDoc', params).then(res => {
				if (res.data.size === 0) {
					this.$message.info('下载文件失败。');
					return;
				}
				const content = res.data;
				const blob = new Blob([content]);
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				var fileName;
				// if (this.selectRows.length === 1) {
				//   if (dianzOrZhizFpFlag) {
				//       if (fileType == 1) {
				//           fileName = date + '-' + row.fapdm + '-' + row.faphm + '.pdf'; // TODO 判断纸票电票
				//       } else {
				//           fileName = date + '-' + row.fapdm + '-' + row.faphm + '.ofd'; // TODO 判断纸票电票
				//       }
				//   } else {
				//     fileName = date + '-' + row.fapdm + '-' + row.faphm + '.pdf';
				//   }
				// } else {
				//   fileName = date + '.zip'
				// }
				fileName = res.headers['content-disposition'].split(';')[1].split('=')[1];
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
			});
		},
		printPaperInvWs(wsurl, invoiceData, params) {
			wsurl = 'ws://127.0.0.1:50926/SysSvr'; // TODO 如果要改蒙柏客户端端口配置就去掉这行
			let ws = new WebSocket(wsurl);
			console.info('ws connect');
			console.info(JSON.stringify(invoiceData));
			console.info(JSON.stringify(params));
			for (let i = 0; i < invoiceData.data.length; i++) {
				invoiceData.data[i].bigjshj = invoiceData.data[i].bigjshj.replaceAll('元', '圆');
			}
			ws.onopen = function() {
				console.info('ws.onopen');
				let invoice = { cmd: 'sendcmd', moduledll: 'InvoiceSvrDll.dll', senddata: invoiceData };

				console.info(invoice);
				ws.send(JSON.stringify(invoice));
			};
			let globalthis = this;
			ws.onmessage = function(evt) {
				console.info('ws.onmessage');
				let data = JSON.parse(evt.data);
				console.log('ws message' + data);
				if (data.code == 0 && (data.cmd == 'print' || data.cmd == 'printDirectly')) {
					globalthis.$https
						.fetchPost('/real/updatePaperInvoiceStatus', JSON.stringify(params))
						.then(res => {
							console.info('更新打印状态结果 : ' + JSON.stringify(res.data));
							if (res.data.success) {
								this.getInvoiceQueryList(this.orderInfo);
							}
						})
						.catch(err => {
							console.error(err);
						});
				}
			};
		},
		handleClick(index, title, row) {
			if (row.fapzl == '2') {
				this.previewtk(row.danjh);
				return false;
			}
			this.title = title;
			this.allitem = JSON.parse(JSON.stringify(this.allitemList[index]));
			if ((this.allitem.priceall == null || this.allitem.priceall.length == 0) && this.allitem.listoflists.length > 0) {
				this.allitem.priceall = [{ type: 4 }];
			}

			// 判断是否含税，并且是否含有全部明细。（实际上是清单发票会没有priceall这个对象）
			if (this.allitem.stateall.istaxincluded && this.allitem.priceall) {
				this.allitem.priceall.forEach(r => {
					if (r.unitPrice) {
						//       if (r.quantity && r.quantity > 1) {
						//         r.unitPrice = (r.unitPrice - (r.taxRatemoney / r.quantity)).toFixed(2);
						//       } else {
						//          r.unitPrice = r.unitPrice - r.taxRatemoney;
						//       }
						if (r.quantity && !isNaN(r.taxRate)) {
							// r.unitPrice = ((r.chooseMoney / (parseFloat(r.taxRate)  + 1) )/ r.quantity).toFixed(15);
							r.unitPrice = this.numdiv(this.numdiv(r.chooseMoney, parseFloat(r.taxRate) + 1), r.quantity).toFixed(15);
						}
						//       let charLength = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1).length;
						//    if(charLength>15){
						//        r.unitPrice = parseFloat(r.unitPrice).toFixed(15);
						//        let charSuffix = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1);
						//         if(charSuffix == '000000000000000'){
						//             r.unitPrice = parseFloat(r.unitPrice).toFixed(2);
						//          }
						//         }
					}
					r.chooseMoney = r.chooseMoney - r.taxRatemoney;
					r.chooseMoney = parseFloat(r.chooseMoney).toFixed(2);
				});
			}
			let selectData = this.selectRows[0];
			// if (this.selectRows[0].faplxdm == "004" || this.selectRows[0].faplxdm == "028") {
			//     this.$https.fetchPost("/doc/getKaipjByKaipjbh",{kaipjbh:this.selectRows[0].kaipzddm}).then(res => {
			//         if (res.data.success) {
			//             let kpj = res.data.obj;
			//             if (kpj != null) {
			//                 if (kpj.equipmentType !='' && kpj.equipmentType != null) {
			//                     this.$https.fetchPost("/redLetter/getRealLetterInfo",{faphm:selectData.faphm,fapdm:selectData.fapdm}).then(res1 => {
			//                         if (res1.data.success) {
			//                             let realLetterInfo = res1.data.obj;
			//                             if (kpj.equipmentType == '0') {
			//                                 this.allitem.bztext = '开具红字增值税专用发票信息表编号' + realLetterInfo.xinxbbh
			//                             } else if (kpj.equipmentType == '1') {
			//                                 this.allitem.bztext = '红字发票信息表编号' + realLetterInfo.xinxbbh
			//                             } else if (kpj.equipmentType == '2') {
			//                                 this.allitem.bztext = '红字发票信息表编号:' + realLetterInfo.xinxbbh
			//                             }
			//                         }
			//                     });
			//                 }
			//             }
			//         }
			//     })
			// }
			this.outerVisible = true;
		},
		//预览
		previewtk(danjh) {
			let params = danjh;
			this.$https.fetchPost('felec/positiveInvoice/getDocInformByDocument', params).then(res => {
				if (res.data.code == '200') {
					//发票明细
					this.priceall = [];
					for (var i = 0; i < res.data.data.detailVos.length; i++) {
						if (res.data.data.detailVos[i].faphxz == '1') {
							this.priceall.push({
								taxCode: res.data.data.detailVos[i].shuisbm,
								goodsName: res.data.data.detailVos[i].shangpmc,
								chooseMoney: res.data.data.detailVos[i].jine,
								taxRate: res.data.data.detailVos[i].shuil,
								taxRatemoney: res.data.data.detailVos[i].shuie,
								itemNo: res.data.data.detailVos[i].hangh,
								type: 1
							});
						} else {
							this.stateall.istaxincluded = res.data.data.detailVos[i].hansbz == 1 ? true : false;
							this.priceall.push({
								unitPrice: res.data.data.detailVos[i].danj,
								unit: res.data.data.detailVos[i].danw,
								spec: res.data.data.detailVos[i].guigxh,
								itemNo: res.data.data.detailVos[i].hangh,
								chooseMoney: res.data.data.detailVos[i].jine,
								taxCode: res.data.data.detailVos[i].shuisbm,
								goodsName: res.data.data.detailVos[i].shangpmc,
								quantity: res.data.data.detailVos[i].shangpsl,
								taxRatemoney: res.data.data.detailVos[i].shuie,
								taxRate: res.data.data.detailVos[i].shuil,
								type: res.data.data.detailVos[i].faphxz
							});
						}
					}
					//开票人
					this.kaipr = res.data.data.doc.kaipr;
					//备注
					this.bztext = res.data.data.doc.beiz;
					//发票类型代码
					this.stateall.choosetitleindex = res.data.data.doc.faplxdm;
					this.stateall.faphm = res.data.data.doc.faphm;
					this.stateall.kaiprq = res.data.data.doc.kaiprq;
					//购方信息
					this.ruleFormb.address = res.data.data.doc.goufdzdh;
					this.ruleFormb.customerName = res.data.data.doc.goufmc;
					this.ruleFormb.taxIdentificationNumber = res.data.data.doc.goufsbh;
					this.ruleFormb.bank = res.data.data.doc.goufyhzh;
					//销方
					this.ruleFormbxiao.addressPhone = res.data.data.doc.xiaofdzdh;
					this.ruleFormbxiao.name = res.data.data.doc.xiaofmc;
					this.ruleFormbxiao.taxNumber = res.data.data.doc.xiaofsbh;
					this.ruleFormbxiao.bankAccount = res.data.data.doc.xiaofyhzh;
					//经办人信息
					this.jbrdata.xingm = res.data.data.doc.goufjbrxm;
					this.jbrdata.zhengjhm = res.data.data.doc.goumfjbrzjhm;
					this.jbrdata.zhengjlx = res.data.data.doc.goumfjbrzjlx;
					this.jbrdata.guoj = res.data.data.doc.jinbrgj;
					this.jbrdata.qiybh = res.data.data.doc.jinbrzrrnsrsbh;
					//单据号
					this.danjh = res.data.data.doc.danjh;
					//特定业务
					this.tdywxz = res.data.data.doc.tedywlx == null ? '' : res.data.data.doc.tedywlx;
					//差额征税 减按征税
					this.cezsxz = res.data.data.doc.chaezslx == null ? '' : res.data.data.doc.chaezslx;
					this.jazsxz = res.data.data.doc.jianazs == null ? '' : res.data.data.doc.jianazs;
					//合计
					this.totalall.pricetotal = res.data.data.doc.hejje;
					this.totalall.taxtotal = res.data.data.doc.hejse;
					this.totalall.jiastotal = res.data.data.doc.jiashj;
					this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
					//特定业务类型
					if (res.data.data.specificBusinessData != null) {
						this.tedxx = res.data.data.specificBusinessData;
						this.tedxx.zulqqzulqz = ['', ''];
						this.tedxx.zulqqzulqz[0] = res.data.data.specificBusinessData.zulqq;
						this.tedxx.zulqqzulqz[1] = res.data.data.specificBusinessData.zulqz;
					}
					//附加内容
					this.srk = [];
					for (var i = 0; i < res.data.data.additionalElementsVos.length; i++) {
						this.srk.push({
							fujxxmc: res.data.data.additionalElementsVos[i].fujysmc,
							deit: res.data.data.additionalElementsVos[i].fujysnr,
							shujlx: res.data.data.additionalElementsVos[i].shujlx,
							id: res.data.data.additionalElementsVos[i].id
						});
					}
					if (res.data.data.doc.faplxdm == '026') {
						this.title = '电子发票(普通发票)';
					} else if (res.data.data.doc.faplxdm == '028') {
						this.title = '电子发票（增值税专用发票）';
					} else if (res.data.data.doc.faplxdm == '007') {
						this.title = '纸质发票(普通发票)';
					} else if (res.data.data.doc.faplxdm == '004') {
						this.title = '纸质发票(专票填开)';
					}
					this.Preview = true;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		excelExport(type) {
			if (type == '1' || type == '0') {
				//this.getImportTemplate();
				this.importSystemTemplate(type);
				return;
			}
			if (type == '4') {
				this.getImportTemplate();
				return;
			}
			var newForm = JSON.parse(JSON.stringify(this.searchalllist));
			if (newForm.kaiprq) {
				newForm.kaiprq = newForm.kaiprq.join(',');
			}
			if (newForm && newForm.chuangjrq) {
				newForm.chuangjrq = newForm.chuangjrq.join(',');
			}
			newForm.ids = this.selectIds.toString();
			// newForm.type = type;
			let importColumn = this.headData.map(item => item.prop);
			if (importColumn.length == 0) {
				this.$message.error('要导出的数据为空！');
				return;
			}
			let params = {
				page: this.page,
				limit: this.pagenum,
				sort: 'desc',
				order: 'rd.kaiprq',
				search: newForm,
				param: { importColumn: importColumn.toString(), type: type }
			};
			this.$https.fetchdowload('/real/exportCustomRealDoc', params).then(res => {
				const content = res.data;
				const blob = new Blob([content]);
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				var companyName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
				const fileName = companyName + date + '发票查询' + '.xls';

				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
			});
		},

		importSystemTemplate(type) {
			var newForm = JSON.parse(JSON.stringify(this.searchalllist));
			if (newForm.kaiprq) {
				newForm.kaiprq = newForm.kaiprq.join(',');
			}
			if (newForm && newForm.chuangjrq) {
				newForm.chuangjrq = newForm.chuangjrq.join(',');
			}
			newForm.ids = this.selectIds.toString();
			newForm.type = type;
			let params = {
				page: this.page,
				limit: this.pagenum,
				sort: 'desc',
				order: 'rd.kaiprq',
				search: newForm
			};
			this.$https.fetchdowload('/real/exportRealDoc', params).then(res => {
				const content = res.data;
				const blob = new Blob([content]);
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				var companyName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
				const fileName = companyName + date + '发票查询' + '.xls';

				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
			});
		},
		checkSort(data) {
			for (let i = 0; i < data.length; i++) {
				let next = i + 1;
				if (next < data.length) {
					if (data[next] - data[i] > 1) {
						return false;
					}
				}
			}
			return true;
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/ .el-input--suffix .el-input__inner {
	padding-right: 15px;
}

.shousuo:extend(.Verticalcenter) {
	height: 20px;
	margin-bottom: 10px;
	background-color: #f8f8f8;
}

.shousuo:hover {
	background: #f8f8f8;
}

.minheight {
	height: 50px;
	overflow: hidden;
	transition: all 0.3s ease;
}

.maxheight {
	height: 400px;
	transition: all 0.3s ease;
}

/deep/ .el-dialog__body {
	padding: 30px 20px !important;
}

/deep/ .el-table--small td {
	padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
	min-height: 160px;
}

.topspan > span {
	font-size: 17px;
	color: #0080ff;
}

.areatable {
	margin-top: 27px;
}

.areacontent {
	margin-left: 21px;
}

// 处理下内部样式
/deep/.el-scrollbar__wrap {
	overflow: hidden scroll !important;
	max-height: 200px !important;
}
</style>
